import { Observable, of } from "rxjs";
import { BaseFlowComponent } from "../base-flow-component/base-flow-component";
import { CompleteActivitySummaryData } from "./complete-activity-summary-data";
import { Component } from "@angular/core";
import { ActivitiesService } from "../../../../services/activities.service";
import { NotificationService } from "../../../../../core/services/notification.service";
import { DevicesService } from "../../../../services/devices.service";
import { tap } from "rxjs/operators";

@Component({
    selector: 'complete-activity-summary',
    templateUrl: './complete-activity-summary.component.html',
    styleUrls: ['./complete-activity-summary.component.scss',
        '../../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class CompleteActivitySummaryComponent extends BaseFlowComponent<CompleteActivitySummaryData> {

    constructor(
        public activitiesService: ActivitiesService,
        public notificationService: NotificationService,
        public devicesService: DevicesService,
    ) {
        super();
    }
    validationError = false;

    initData() {
    }

    saveChanges(): Observable<any> {
        return of({});
    }

    validateDevices(){
        if (this.data.installGeneralDevices.length > 0) {
            this.dataSaving = true;

            this.devicesService.reservedEqualUsed(this.data.requestId, this.data.devicesToInstall)
            .pipe(
                tap(() => this.dataSaving = false)
            )
            .subscribe((resp) => {
                if (!resp.data) {
                    this.validationError = true;
                }
                else
                    this.goToNext();
            });
        }
        else {
            this.goToNext();
        }
    }

    goBack(){
        this.validationError = false;
    }

    get hasUninstallDevices(): boolean {
        if (this.data.uninstallGeneralDevices != null && this.data.uninstallGeneralDevices.length > 0) {
            let device = this.data.uninstallGeneralDevices[0];
            let deviceDataIsEmpty = this.isEmpty(device.serialNumber) && this.isEmpty(device.nomenclature) && this.isEmpty(device.partNumber);
            return !deviceDataIsEmpty;
        }

        return false;
    }

    isEmpty(value: string): boolean {
        return value == null || value.trim() == '';
    }
}